import importerActions from 'modules/shared/importer/importerActions';
import selectors from 'modules/botFlow/importer/botFlowImporterSelectors';
import BotFlowService from 'modules/botFlow/botFlowService';
import fields from 'modules/botFlow/importer/botFlowImporterFields';
import { i18n } from 'i18n';

export default importerActions(
  'BOT_FLOW_IMPORTER',
  selectors,
  BotFlowService.import,
  fields,
  i18n('entities.botFlow.importer.fileName'),
);
